import React from "react";
import { Link } from "react-router-dom";

export default () => (
  <div
    className="signin animated fadeIn mar-b-100 mar-t-100"
    style={{ color: "black" }}
  >
    <div className="box-outer">
      <div className="box-inner">
        <h1>Email Sent</h1>
        <div>
          <p>
            Your email was sent to the CardCash customer service team. Please
            allow for 1-2 business days for customer service to reach back with
            you.
          </p>
          <span>Do you have another question?</span>
          <br />
          <span className="lnk">
            <Link to="/contact">We enjoy hearing your feedback.</Link>
          </span>
        </div>
      </div>
    </div>
  </div>
);
